import VTeamSelector from '../../team/components/v-selector';
import VListContainer from '../../../vuetify_custom/v-list-container';
import VPage from '../../../vuetify_custom/v-pagination';

export default {
  components: { VTeamSelector, VListContainer, VPage },
  data() {
    return {
      loading: false,
      params: {
        search: '',
        page: 1,
        per_page: 20,
        search_type: 'all'
      },
      page_info: {
        current: 1,
        total: 0,
        page_size: 10
      },
      bill_query_path: '',
      bills: []
    }
  },
  computed: {
    //
  },
  created() {
    this.query();
  },
  mounted() {
    //
  },
  methods: {
    query() {
      if (!this.bill_query_path) {
        throw '请指定bill_query_path';
      }
      this.$nextTick(() => {
        this.bills = [];
        this.loading = true;
        this.$http.get(this.bill_query_path, this.params)
          .then(({ bills, cur_page, per_page, total_count }) => {
            this.bills = bills;
            this.page_info.current = cur_page;
            this.page_info.total = total_count;
            this.page_info.page_size = per_page;
          })
          .finally(() => {
            this.loading = false;
          });
      })
    },
    pageChange(page) {
      this.params.page = page;
      this.query();
    },
    search() {
      this.pageChange(0);
    },
    // text-field clear 不会立即清除 v-model
    searchClear() {
      this.params.search = '';
      this.search();
    }
  }
}
